import React, { Component } from "react";
import { connect } from "react-redux";
import {
  InterationNotifier,
  ShowInfoDisplay,
  RemoveRemoteNotifier,
  AlterScreen,
} from "../actions";
// import TeamModal from '../modals/TeamModal'
import { toast, toast as toastchat } from "react-toastify";
import toastError, { Toaster as ToasterSecond } from "react-hot-toast";

import "react-toastify/dist/ReactToastify.css";
import MicroModal from "micromodal";
import LOGOINGWEB from "../build/images/logo_ingweb_notify.svg";

import { ReactComponent as DangerIcon } from "../build/images/dangericonred.svg";
import { ReactComponent as DangerYellow } from "../build/images/danger.svg";
import { ReactComponent as IconClose } from "../build/images/closecircle22px.svg";

const { connection_platform } = require("../services/api");

var exitscreen = false;

function isMobileDevice() {
  // Verificar se o navegador está em um dispositivo móvel através do User-Agent
  const userAgent = navigator.userAgent;
  const mobileDeviceRegex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  return mobileDeviceRegex.test(userAgent);
}

function createJSON(item) {
  if (item) {
    var mensagem_tratada = item.replace(/¿/gi, "\n");
    mensagem_tratada = mensagem_tratada.replace(/§/gi, "\r\n");
    let valor = 1;
    try {
      mensagem_tratada =
        '{"' + valor + '": [{"mensagem_tratada":"' + mensagem_tratada + '"}]}';
      var obj = JSON.parse(mensagem_tratada);
      mensagem_tratada = obj[1][0].mensagem_tratada;
    } catch (e) {
      mensagem_tratada = item;
    }
    return mensagem_tratada;
  }
}
// Solicita a permissão para realizar as notificações
document.addEventListener("DOMContentLoaded", function () {
  if (Notification.permission != "granted") Notification.requestPermission();
});
// Função para exibir as notificações
function NofiticacaoGoogleChrome() {
  if (!Notification) {
    alert(
      "NotificaÃ§Ãµes de Ã¡rea de trabalho que nÃ£o estÃ£o disponÃ­veis no seu navegador. Tente com o navegador Google Chrome"
    );
    return;
  }

  if (Notification.permission != "granted") Notification.requestPermission();
  else {
    var notification = new Notification("Notificação IngWeb", {
      icon: "https://cdn3.iconfinder.com/data/icons/ose/Warning.png",
      body: "Notificação Navegador",
    });

    notification.onclick = function () {
      window.open("http://site.com.br/pagina.html");
    };
  }
}

toast.configure();
toastchat.configure({
  position: toast.POSITION.TOP_RIGHT,
  autoClose: false,
  draggable: false,
  closeOnClick: true,
  hideProgressBar: false,
});

function spawnNotification(opcoes) {
  var n = new Notification(opcoes.title, opcoes.opt);
}

function handleClick(closeToast, props, remote, screen) {
  closeToast();
  props.RemoveRemoteNotifier(remote);
  props.AlterScreen("ChatGrupo", screen);
  MicroModal.show("modal__mensagem-equipe");
}

function addEvent(obj, evt, fn) {
  if (obj.addEventListener) {
    obj.addEventListener(evt, fn, false);
  } else if (obj.attachEvent) {
    obj.attachEvent("on" + evt, fn);
  }
}

addEvent(window, "load", function (e) {
  addEvent(document, "mouseout", function (e) {
    e = e ? e : window.event;
    var from = e.relatedTarget || e.toElement;
    if (!from || from.nodeName == "HTML") {
      exitscreen = true;
    } else {
      exitscreen = false;
    }
  });
});

const Msg = ({ closeToast, texto, status, props, remote, screen }) => {
  return (
    <>
      {(() => {
        if (status === "chat") {
          return (
            <div
              className="toast-alert"
              onClick={() => props.ShowInfoDisplay("Atendentes", remote)}
            >
              <div className="toast-alert__title">
                <div
                  className="toast-alert__title__icon item-notification--chat-group"
                  onClick={() => props.ShowInfoDisplay("Atendentes", remote)}
                >
                  <i
                    onClick={() => props.ShowInfoDisplay("Atendentes", remote)}
                    className="material-icons"
                  >
                    question_answer
                  </i>
                </div>
                <div
                  onClick={() => props.ShowInfoDisplay("Atendentes", remote)}
                  className="toast-alert__title__name"
                >
                  {texto}
                </div>
              </div>
            </div>
          );
        } else if (status === "chatgrupo") {
          return (
            <div
              className="toast-alert"
              onClick={() => handleClick(closeToast, props, remote, screen)}
            >
              <div className="toast-alert__title">
                <div
                  className="toast-alert__title__icon  item-notification--chat-group"
                  onClick={() => handleClick(closeToast, props, remote, screen)}
                >
                  <i
                    onClick={() =>
                      handleClick(closeToast, props, remote, screen)
                    }
                    className="material-icons"
                  >
                    announcement
                  </i>
                </div>
                <div
                  onClick={() => handleClick(closeToast, props, remote, screen)}
                  className="toast-alert__title__name"
                >
                  {texto}
                </div>
              </div>
            </div>
          );
        } else {
          return (
            <div className="toast-alert">
              <div className="toast-alert__title">
                <div className="toast-alert__title__icon">
                  <i className="material-icons">warning</i>
                </div>
                <div className="toast-alert__title__name">{texto}</div>
              </div>
            </div>
          );
        }
      })()}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    Notifications: state.notifications,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ClearNotifier: (post) => {
    dispatch(InterationNotifier(post));
  },
  ShowInfoDisplay: (post, remote) => {
    dispatch(ShowInfoDisplay(post));
    dispatch(RemoveRemoteNotifier(remote));
    dispatch(AlterScreen("Atendentes"));
  },
  AlterScreen: (post, previous) => {
    dispatch(AlterScreen(post, previous));
  },
  RemoveRemoteNotifier: (remote) => {
    dispatch(RemoveRemoteNotifier(remote));
  },
});

const closeToastErrordb = () => {
  toastError.remove();
};

class Notifications extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: "", auxnotification: "iniciando" };
  }

  ShowNotifier(texto, status, remote, screen) {
    if (status === "permission") {
      toast.info(texto, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }

    if (status === "errordb") {
      toastError.custom(
        <div className="container__pause-automatic_remove">
          <div className="container__pause-automatic__icon">
            <DangerIcon />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>OPS...!</strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={() => closeToastErrordb()}
              >
                <IconClose />
              </div>
            </div>
            <span>{texto}</span>
          </div>
        </div>
      );
    }

    if (status === "automaticpause") {
      toastError.custom(
        <div className="container__pause-automatic">
          <div className="container__pause-automatic__icon">
            <DangerYellow />
          </div>
          <div className="container__pause-automatic__separator">
            <div className="container__pause-automatic__box">
              <strong>Fique atento ...!</strong>
              <div
                className="container__pause-automatic__box-icon"
                onClick={() => closeToastErrordb()}
              >
                <IconClose />
              </div>
            </div>
            <span>{texto}</span>
          </div>
        </div>
      );
    }

    if (exitscreen === true) {
      if (connection_platform.type_connect === "http") {
        if (status === "call") {
          toast.info(texto, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } else if (status === "chat" || status === "chatgrupo") {
          toastchat(
            <Msg
              texto={texto}
              status={status}
              props={this.props}
              remote={remote}
              screen={screen}
            />,
            {
              className: "toast-alert-content",
              hideProgressBar: false,
              autoClose: 5000,
              className: "toast-alert-content",
              hideProgressBar: true,
            }
          );
        } else if (status === "50") {
          toast.info(texto, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } else if (status === "toastgrupo") {
          toast.error(texto, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      } else {
        if (status === "call") {
          if (!isMobileDevice()) {
            spawnNotification({
              opt: {
                body: "Notificação IngWeb",
                icon: LOGOINGWEB,
              },
              title: createJSON(texto),
            });
          }
        } else if (status === "chat" || status === "chatgrupo") {
          if (!isMobileDevice()) {
            spawnNotification({
              opt: {
                body: "Notificação IngWeb",
                icon: LOGOINGWEB,
              },
              title: createJSON(texto),
            });
          }
        } else if (status === "50") {
          toast.info(texto, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        } else if (status === "toastgrupo") {
          toast.error(texto, {
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 5000,
          });
        }
      }
    } else if (status === "50") {
      toast.info(texto, {
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 5000,
      });
    }
  }

  ShowInfoDisplay(e, display, remote) {
    if (display === "mensagemchat") {
      this.props.ShowInfoDisplay("Atendentes");
      this.props.RemoveNotifier(remote);
    }
  }

  render() {
    const { Notifications } = this.props;

    if (Notifications.length != 0) {
      this.ShowNotifier(
        Notifications.texto,
        Notifications.status,
        Notifications.remote,
        Notifications.screen
      );
    }

    return (
      <div style={{ display: "none" }}>
        <div id="notifier" style={{ display: "none" }}>
          <button
            type="button"
            id="btn_permission"
            onClick={() => this.showToast()}
          >
            Permission
          </button>
        </div>
        <div
          className="modal micromodal-slide"
          id="modal__mensagem-equipe"
          aria-hidden="true"
          role="dialog"
        >
          {/* <TeamModal /> */}
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
